import styled from 'styled-components/macro';
import { smallScreens } from '../../../../../common/fontElements';

export const GalleryWrapper = styled.div`
  margin-bottom: 80px;

  @media (max-height: ${smallScreens}) {
    margin-bottom: 40px;
  }
`;
